<template>
  <div class="body-wrapper">
    <Header :title="'Feedback'" />
    <div class="body-container">
      <div class="tab-container">
        <ul class="tabs">
          <li 
            :class="{'selected': selectedTab === 'waiting'}"
            @click="changeTab('waiting')">
              NEW FEEDBACK
          </li>
          <li 
            :class="{'selected': selectedTab === 'approved'}"
            @click="changeTab('approved')">
              APPROVED
          </li>
          <li 
            :class="{'selected': selectedTab === 'rejected'}"
            @click="changeTab('rejected')">
              REJECTED
          </li>
        </ul>
        <div class="tab-body" @scroll="onScroll">
          <div class="tab" v-if="selectedTab === 'waiting'">
            <UserFeedback 
              v-for="(feedback, index) in waitingFeedback" 
              :key="feedback.id + index"
              :feedback="feedback"
              :action-type="'waiting'" />
          </div>
          <div class="tab" v-if="selectedTab === 'approved'">
            <UserFeedback 
              v-for="(feedback, index) in approvedFeedback" 
              :key="feedback.id + index"
              :feedback="feedback"
              :action-type="'approved'" />
          </div>
          <div class="tab" v-if="selectedTab === 'rejected'">
            <UserFeedback 
              v-for="(feedback, index) in rejectedFeedback" 
              :key="feedback.id + index"
              :feedback="feedback"
              :action-type="'rejected'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import { getFeedback } from '@/api/requests';
import UserFeedback from "@/components/feedback/UserFeedback";

export default {
  name: 'Feedback',

  components: {
    Header,
    UserFeedback
  },

  data() {
    return {
      selectedTab: 'waiting',
      load: 0,
      maxLoaded: false,
    };
  },

  mounted() {
    this.loadFeedback('waiting');
  },

  methods: {
    changeTab(tab) {
      this.load = 0;
      this.maxLoaded = false;
      this.selectedTab = tab;
      this.loadFeedback(tab);
    },

    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= scrollHeight) {
        this.load++; 
        this.loadFeedback(this.selectedTab);
      }
    },

    loadFeedback(type) {
      const params = {
        type,
        load: this.load,
      };
      if (!this.maxLoaded) {
        getFeedback(params).then(response => {
          let payload = {
            type: type + 'Feedback',
            value: response.data
          };
          this.maxLoaded = response.data.length < 20;
          if (this.load > 0) {
            this.$store.commit('feedback/loadMore', payload);
          } else {
            this.$store.commit('feedback/setOriginalValue', payload);
          }
        }).catch(() => {
          // TODO errors
        });
      }
    },
  },

  computed: {
    waitingFeedback() {
      return this.$store.state.feedback.waitingFeedback;
    },

    approvedFeedback() {
      return this.$store.state.feedback.approvedFeedback;
    },

    rejectedFeedback() {
      return this.$store.state.feedback.rejectedFeedback;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.body-container {
  padding: $spacing_base;
  height: calc(100% - 60px);

  .container {
    height: calc(100% - 60px);
    border: 1px solid $sec6;
    margin-bottom: $spacing-base;
  }
  .container-header {
    padding: $spacing-base;
    background: $sec7;
    border-bottom: 1px solid $sec6;
    display: flex;
    flex-direction: row;

    h3 {
      padding: 0;
      margin: 0;
      flex: 1;
      font-weight: normal;
      font-size: 1em;
      color: $sec2;
      line-height: 25px;
    }

    .report-actions {
      button {
        margin-left: $spacing-small;
      }
    }
  }
  .container-body {
    height: calc(100% - 44px);
    overflow-y: scroll;
  }
}

.tab-container {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    height: 28px;
    margin-bottom: $spacing-base;
    
    li {
      float: left;
      padding-left: $spacing-large;
      padding-right: $spacing-large;
      padding-bottom: $spacing-small;
      border-bottom: 3px solid $sec1;
      color: $sec1;
      font-weight: bold;
      font-size: $font-size-base;
      user-select: none;
      cursor: pointer;
    }

    .selected {
      color: $blue;
      border-color: $blue;
    }
  }

  .tab-body {
    height: calc(100vh - 200px);
    overflow-y: scroll;
  }
}
</style>
